<template>
  <div class="container">
    <div class="row" id="contact">
      <div class="col-md-12">
        <h2>Any questions? Feel free to contact us.</h2>
        <form @submit.prevent="sendEmail">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control mt-2"
                  placeholder="Company"
                  v-model="sender_company"
                  readonly
                  required
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control mt-2"
                  placeholder="First and Last name"
                  v-model="sender_name"
                  readonly
                  required
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <input
                  type="email"
                  class="form-control mt-2"
                  placeholder="E-mail"
                  v-model="sender_email"
                  readonly
                  required
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <input
                  type="number"
                  class="form-control mt-2"
                  placeholder="Phone Number"
                  required
                  v-model="sender_phone"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  placeholder="Message"
                  rows="5"
                  required
                  v-model="sender_message"
                ></textarea>
              </div>
            </div>
            <div class="col-12">
              <button class="form-control btn btn-success" type="submit">Submit</button>
            </div>
          </div>
        </form>

        <div>
          <h2>Contact Info</h2>
          <i class="fas fa-phone mt-3"></i>
          <a href="tel:+">(+509) 2811-0248</a> /
          <a href="tel:+">(+509) 2813-0739</a>
          <a href="tel:+">(+509) 4773-4928</a>
          <br />
          <i class="fa fa-envelope mt-3"></i>
          <a href="mailto:decsa@decsahaiti.com">decsa@decsahaiti.com</a>
          <!--<br />
          <i class="fas fa-globe mt-3"></i>17 Boulevard Toussaint Louverture, Angle Rue Jn Gilles Port-au-Prince HT, 6110
          <br />
          <i class="fas fa-globe mt-3"></i> Boulevard la Saline, Port-Au-Prince, Haiti-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import emailjs from "emailjs-com";
import { mapState } from "vuex";
export default {
  name: "contact",
  data() {
    return {
      sender_company: "",
      sender_email: "",
      sender_name: "",
      sender_phone: "",
      sender_message: "",
    };
  },
  computed: {
    ...mapState(["isLoggedIn", "user", "account"]),
  },
  methods: {
    sendEmail: function () {
      /*let payload = {
        sender_company: this.sender_company,
        sender_email: this.sender_email,
        sender_name: this.sender_name,
        sender_phone: this.sender_phone,
        sender_message: this.sender_message,
      };*/

      let sender_company = this.sender_company;
      let sender_email = this.sender_email;
      let sender_name = this.sender_name;
      let sender_phone = this.sender_phone;
      let sender_message = this.sender_message;

      let payload = {
        sender_company,
        sender_email,
        sender_name,
        sender_phone,
        sender_message,
      };

      this.$store
        .dispatch("sendEmail", payload)
        .then(() => {
          //this.message = error.response.data.fault.faultstring;
          this.message = "Your message has been sent.";
          this.$toast.success(this.message, {
            position: "top",
            onClose: () => this.$router.push("/portal"),
          });
        })
        .catch((error) => {
          //this.errored = true;
          this.message = error.response.data.fault.faultstring;
          this.message = "Unfortunatly, Your message could not be delivered.";
          this.$toast.error(this.message, {
            position: "top",
          });
        });
      /*emailjs
        .sendForm(
          "YOUR_SERVICE_ID",
          "YOUR_TEMPLATE_ID",
          e.target,
          "YOUR_USER_ID"
        )
        .then(
          (result) => {
            console.log("SUCCESS!", result.status, result.text);
          },
          (error) => {
            console.log("FAILED...", error);
          }
        );*/
    },
  },
  created() {
    (this.sender_company = this.account.name),
      (this.sender_email = this.user.email),
      (this.sender_name =
        this.user.first_name +
        " " +
        this.user.middle_name +
        " " +
        this.user.last_name);
  },
};
</script>

